var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{
      'is-loading': _vm.loading,
      'soft-disabled': _vm.softDisabled
    },attrs:{"type":_vm.btnType},on:{"click":function($event){return _vm.clickEvent($event)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_vm._t("default")],2),(_vm.loading)?_c('span',{staticClass:"loader"},[_c('Loader',{attrs:{"size":'small',"align":'center'}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }